<template>
  <Modal v-model="visible" :title="isEdit ? '编辑图套信息' : '新建语言专属图套'" width="420px" :footer-hide="true"
    @on-cancel="close">
    <div class="sku-add-set-modal-body">
      <!-- 图套显示名称 -->
      <div class="sku-add-set-row">
        <label class="sku-add-set-label">图套显示名称</label>
        <Input v-model="setName" placeholder="如：冬款质感主图" :maxlength="30" class="sku-add-set-input" />
        <div v-if="nameErr" class="sku-add-set-err">{{ nameErr }}</div>
      </div>
      <!-- 图套类型定义 -->
      <div class="sku-add-set-row">
        <label class="sku-add-set-label">图套类型定义</label>
        <div class="sku-add-set-type-list">
          <label v-for="opt in typeOptions" :key="opt.value"
            :class="['sku-set-type-option', setType === opt.value ? 'active' : '']"
            @click="setType = opt.value">
            <span class="sku-set-type-radio">
              <span v-if="setType === opt.value" class="sku-set-type-radio-dot"></span>
            </span>
            <span class="sku-set-type-badge-lg" :style="{ background: opt.color }">{{ opt.label }}</span>
          </label>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="sku-add-set-footer">
        <Button @click="close">取消</Button>
        <Button type="primary" style="margin-left:10px;" @click="handleConfirm">{{ isEdit ? '确认修改' :
          '确认创建'
        }}</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'imageSetFormModal',
  data() {
    return {
      visible: false,
      isEdit: false,
      setName: '',
      setType: '1',
      nameErr: '',
      typeOptions: [
        { value: '1', label: '网图', color: '#f90' },
        { value: '2', label: '非实拍自修', color: '#19be6b' },
        { value: '3', label: '实拍自修', color: '#19be6b' }
      ]
    };
  },
  methods: {
    /**
     * 打开弹框
     * @param {'add'|'edit'} mode 新增或编辑模式
     * @param {Object} [data] 编辑模式下传入 { setName, setType } 用于反显
     */
    open(mode, data) {
      this.isEdit = mode === 'edit';
      this.setName = (data && data.setName) || '';
      this.setType = (data && data.setType) || '1';
      this.nameErr = '';
      this.visible = true;
    },
    /** 关闭弹框并重置表单 */
    close() {
      this.visible = false;
      this.setName = '';
      this.setType = '1';
      this.nameErr = '';
    },
    /** 确认：校验后 emit 图套名称和类型 */
    handleConfirm() {
      const name = this.setName.trim();
      if (!name) {
        this.nameErr = '图套名称不能为空';
        return;
      }
      this.$emit('on-confirm', {
        setName: name,
        setType: this.setType,
        isEdit: this.isEdit
      });
    }
  }
};
</script>

<style scoped lang="less">
.sku-add-set-modal-body {
  padding: 4px 8px 0;
}

.sku-add-set-row {
  margin-bottom: 18px;
}

.sku-add-set-label {
  display: block;
  font-size: 13px;
  color: #17233d;
  font-weight: 600;
  margin-bottom: 8px;
}

.sku-add-set-input {
  width: 100%;
}

.sku-add-set-err {
  color: #ed4014;
  font-size: 12px;
  margin-top: 4px;
}

.sku-add-set-type-list {
  display: flex;
  gap: 16px;
}

.sku-set-type-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  color: #515a6e;
}

.sku-set-type-radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  transition: border-color 0.2s;
}

.sku-set-type-option.active .sku-set-type-radio {
  border-color: #2d8cf0;
}

.sku-set-type-radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2d8cf0;
}

.sku-set-type-badge-lg {
  display: inline-block;
  font-style: normal;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  line-height: 1.6;
  font-weight: 600;
}

.sku-add-set-footer {
  text-align: right;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
}
</style>
